import * as types from '../actions/types';

const initialState = {
  individualWorkPlanTab: []
};

export default function individualWorkPlan(state = initialState, action) {
  switch (action.type) {
    case types.INDIVIDUAL_WORK_PLAN_FETCH_COMPLETED:
      return {
        ...state,
        individualWorkPlanList: action.plan
      };
    case types.INDIVIDUAL_WORK_PLAN_FILTER_FETCH_COMPLETED:
      return {
        ...state,
        filtersList: action.plan
      };
    case types.INDIVIDUAL_WORK_PLAN_BY_ID_FETCH_COMPLETED:
      return {
        ...state,
        individualWorkPlanTab: action.plan
      };
    case types.INDIVIDUAL_WORK_PLAN_I_FETCH_COMPLETED:
      return {
        ...state,
        taskForYear: action.plan
      };
    case types.INDIVIDUAL_WORK_PLAN_III_FETCH_COMPLETED:
      return {
        ...state,
        academicWork: action.plan
      };
    case types.INDIVIDUAL_WORK_PLAN_III_FETCH_COMPLETED_TIMES:
      return {
        ...state,
        academicWorkTimes: action.plan
      };
    case types.INDIVIDUAL_WORK_PLAN_III_GROUP_FETCH_COMPLETED:
      return {
        ...state,
        academicWorkGroup: action.plan
      };

    default:
      return state;
  }
}
